<template>
	<div>
		<bread-crumbs
			:bread-crumbs="breadCrumbs"
			:current-title="title"
			class="breadcrumbstyle"
		/>
		<v-card>
			<v-card-title><translate>Reseller Data</translate></v-card-title>
			<v-form
				ref="form"
				v-model="resellerForm"
			>
				<v-row
					align="center"
					class="pa-4"
				>
					<v-col
						cols="5"
					>
						<v-row>
							<v-col
								cols="10"
							>
								<v-text-field
									v-model="companyName"
									:rules="[v => !!v || $gettext('Company Name is required')]"
									:label="$gettext('Company Name')"
									required
									variant="outlined"
								/>
							</v-col>
							<v-col
								cols="2"
							>
								<v-checkbox
									v-model="whiteLabel"
									color="primary"
									:label="$gettext('White Label')"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col
								cols="6"
							>
								<v-text-field
									v-model="registrationNumber"
									:rules="[v => !!v || $gettext('Company Registration Number is required'), v => v.length === 8 || $gettext('Invalid registration number')]"
									type="number"
									:label="$gettext('Company Registration Number')"
									required
									variant="outlined"
								/>
							</v-col>
							<v-col
								cols="6"
							>
								<v-text-field
									v-model="vatNumber"
									:rules="[v => !!v || $gettext('VAT Number is required'), v => (/NL[0-9]{9}B[0-9]{2}/.test(v)) || $gettext('VAT Number is invalid')]"
									:label="$gettext('VAT Number')"
									required
									variant="outlined"
								/>
							</v-col>
						</v-row>
					</v-col>
					<v-col
						cols="5"
					>
						<v-color-picker
							v-model="primaryColor"
							:rules="[v => !!v || $gettext('Color is required')]"
							:label="$gettext('Primary color')"
							required
						/>
					</v-col>
				</v-row>
				<v-card-title><translate>Address</translate></v-card-title>
				<v-row
					align="center"
					class="pa-4"
				>
					<v-col
						cols="4"
					>
						<v-text-field
							v-model="addressStreet"
							:rules="[v => !!v || $gettext('Street Name is required'), v => !(/\d/.test(v)) || $gettext('Street contains numbers')]"
							:label="$gettext('Street Name')"
							required
							variant="outlined"
						/>
					</v-col>
					<v-col
						cols="12"
						sm="4"
					>
						<v-text-field
							v-model="addressNumber"
							:rules="[v => !!v || $gettext('House Number is required')]"
							type="number"
							:label="$gettext('House Number')"
							required
							variant="outlined"
						/>
					</v-col>
					<v-col
						cols="4"
					>
						<v-text-field
							v-model="addressSuffix"
							:label="$gettext('Suffix')"
							variant="outlined"
						/>
					</v-col>
				</v-row>
				<v-row
					align="center"
					class="pa-4"
				>
					<v-col
						cols="4"
					>
						<v-text-field
							v-model="addressPostalCode"
							:rules="[v => !!v || $gettext('Postal code is required')]"
							:label="$gettext('Postal Code')"
							required
							variant="outlined"
						/>
					</v-col>
					<v-col
						cols="4"
					>
						<v-text-field
							v-model="addressCity"
							:rules="[v => !!v || $gettext('City is required'), v => !(/\d/.test(v)) || $gettext('City contains numbers')]"
							:label="$gettext('City')"
							required
							variant="outlined"
						/>
					</v-col>
					<v-col
						cols="4"
					>
						<v-select
							v-model="domain"
							:items="domains"
							:rules="[v => !!v || $gettext('Country is required')]"
							:label="$gettext('Country')"
							item-title="name"
							item-value="id"
							required
							variant="outlined"
						/>
					</v-col>
				</v-row>
				<v-card-actions>
					<v-spacer />
					<v-btn
						color="primary"
						class="mr-4"
						@click="submitReseller"
					>
						<translate>Save</translate>
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</div>
</template>

<script>
import {
	axios,
} from '../../../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';
import {
	keysToSnakeCase,
} from '../../../../util/keys-transform';
import BreadCrumbs from '../../../molecules/BreadCrumbs.vue';

export default {
	name: 'ResellerNew',
	components: {
		BreadCrumbs
	},
	data () {
		return {
			breadCrumbs: {
				'/bo/management/resellers': 'Resellers'
			},
			title: 'New Reseller',
			whiteLabel: false,
			companyName: '',
			addressStreet: '',
			addressNumber: '',
			addressSuffix: '',
			addressPostalCode: '',
			addressCity: '',
			resellerForm: null,
			update: false,
			registrationNumber: '',
			primaryColor: '',
			domain: null,
			domains: [],
			resellerId: null,
			vatNumber: '',
		};
	},

	watch: {
		primaryColor (value) {
			// temporary fix while there is no way to disable the alpha channel in the colorpicker component: https://github.com/vuetifyjs/vuetify/issues/9590
			if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
				this.primaryColor = value.substr(0, 7);
			}
		}
	},

	created () {
		this.getDomains();
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		if (params.get('id')) {
			this.resellerId = params.get('id');
			this.getReseller();
		}
	},
	methods: {
		/**
		 * Send a request to create a new reseller.
		 */
		submitReseller () {
			if (this.$refs.form.validate()) {
				const dataToSend = JSON.stringify(keysToSnakeCase({
					companyName: this.companyName,
					whiteLabel: this.whiteLabel,
					addressStreet: this.addressStreet,
					addressNumber: this.addressNumber,
					addressSuffix: this.addressSuffix,
					addressPostalCode: this.addressPostalCode,
					addressCity: this.addressCity,
					registrationNumber: this.registrationNumber,
					primaryColor: this.primaryColor,
					domain: this.domain,
					update: this.update,
					resellerId: this.resellerId,
					vatNumber: this.vatNumber,
				}));
				const formData = new FormData();

				formData.set('formData', dataToSend);

				axios({
					url: '/bo/management/resellers/submitreseller',
					method: 'POST',
					dataType: 'json',
					data: formData,
					config: {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					},
				}).then(() => {
					inform(this.$gettext('Reseller submission successful'));
					window.location.href = '/bo/management/resellers';
				})
					.catch((error) => {
						inform(this.$gettext('Submission failure.'));
						window.captureException(error);
					});
			} else {
				this.dialog = false;
			}
		},

		/**
		 * Retrieves all of our domains
		 *
		 * @returns {void}
		 */
		getDomains () {
			axios.get('/bo/management/resellers/domains')
				.then(({
					data: data
				}) => {
					this.domains = data;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during get domains request'));
				});
		},

		/**
		 * Get specific reseller
		 *
		 * @returns {void}
		 */
		getReseller () {
			axios.get(`/bo/management/resellers/resellerdata?id=${this.resellerId}`)
				.then(({
					data: data
				}) => {
					this.whiteLabel = data.whiteLabel;
					this.companyName = data.name;
					this.addressStreet = data.street;
					this.addressNumber = data.houseNumber;
					this.addressSuffix = data.houseNumberSuffix;
					this.addressPostalCode = data.postalCode;
					this.addressCity = data.city;
					this.update = true;
					this.registrationNumber = data.registrationNumber;
					this.primaryColor = data.primaryColor;
					this.domain = data.domain;
					this.vatNumber = data.vatNumber;
				})
				.catch(() => {
					displayError(this.$gettext('Something has gone wrong during get reseller request'));
				});
		}
	}
};
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}
</style>
